/** Today, on the next whole hour — the shortest path to a sensible first answer when writing a meeting down. */
export function defaultStart(): Date {
  const start = new Date();
  start.setMinutes(0, 0, 0);
  start.setHours(start.getHours() + 1);
  return start;
}
